module.exports = __webpack_public_path__ + "static/media/straven_1.9f20c131.jpg";